const getAltTagFromFileName = (fileName) => fileName.split('.')[0].split('-').join(' ');

export default getAltTagFromFileName;
